import {
  ProviderFilters,
  SearchFilter,
  WbResponsiveTableToolbar,
} from '@agilelab/plugin-wb-platform';
import useRbacSubjectContext from './RbacSubjectProvider';

export interface RbacSubjectFilters extends ProviderFilters {}

export const RbacSubjectFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    useRbacSubjectContext();

  const filterElement = (key: string) => {
    if (key === 'search')
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    return <></>;
  };

  return (
    <WbResponsiveTableToolbar onClear={resetFilters} marginBottom>
      <WbResponsiveTableToolbar.Filters>
        {(templateKind?.userFilters ?? ['search']).map(filter =>
          filterElement(filter),
        )}
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
